<template>
  <div class="modal-mask">
    <div class="modal-wrapper">
      <div class="modal-container">
        <div class="modal-header">
          <slot name="header">
            <div class="modal-title">
              <span>신규카드등록</span>
            </div>
            <div class="close">
              <i class="fal fa-times fa-fw" @click="closeModal"></i>
            </div>
          </slot>
        </div>
        <div class="modal-body">
          <slot name="body">
            <div class="checkbox-wrap">
              <div class="checkbox" @click="cardType = !cardType">
                <img
                  :src="
                    cardType
                      ? require('@/assets/img/join/check_on.svg')
                      : require('@/assets/img/join/checkbox_off.svg')
                  "
                />
                개인카드 / 법인개별카드
              </div>
              <div class="checkbox" @click="cardType = !cardType">
                <img
                  :src="
                    cardType
                      ? require('@/assets/img/join/checkbox_off.svg')
                      : require('@/assets/img/join/check_on.svg')
                  "
                />
                법인공용카드
              </div>
            </div>
            <FormulateForm #default="{ hasErrors }">
              <div class="input-wrap">
                <FormulateInput
                  type="number-input"
                  name="cardNo"
                  label="카드번호"
                  placeholder="카드번호 입력(-제외)"
                  maxlength="16"
                  error-behavior="value"
                  v-model.trim="cardNo"
                  :validation="[['cardLengthValidation']]"
                />
                <FormulateInput
                  type="number-password"
                  name="cardPw"
                  label="비밀번호 앞 2자리"
                  placeholder="**"
                  maxlength="2"
                  error-behavior="value"
                  v-model.trim="cardPw"
                  :validation="[['cardLengthValidation']]"
                />
                <FormulateInput
                  type="number-input"
                  name="expireMonth"
                  label="유효기간 월"
                  placeholder="MM"
                  maxlength="2"
                  error-behavior="value"
                  v-model.trim="expireMonth"
                  :validation="[['cardLengthValidation']]"
                />
                <FormulateInput
                  type="number-input"
                  name="expireYear"
                  label="유효기간 년"
                  placeholder="YY"
                  maxlength="2"
                  error-behavior="value"
                  v-model.trim="expireYear"
                  :validation="[['cardLengthValidation']]"
                />
                <FormulateInput
                  type="number-input"
                  name="identifyNumber"
                  :label="identifyNumberText.KOR"
                  placeholder="(-)제외 입력"
                  error-behavior="value"
                  maxlength="10"
                  v-model.trim="identifyNumber"
                  :validation="[
                    ['cardLengthValidation', identifyNumberText.ENG]
                  ]"
                />
              </div>
              <div class="btn-wrap">
                <button v-show="!loading" @click="submit" :disabled="hasErrors">
                  카드 등록
                </button>
                <button v-show="loading" disabled>
                  <i class="far fa-spinner fa-spin fa-fw"></i>
                </button>
              </div>
            </FormulateForm>
          </slot>
        </div>
      </div>
    </div>
  </div>
</template>

<style src="./../ModalCommon.css" scoped></style>
<style src="./index.css" scoped></style>

<script>
/* eslint-disable */

export default {
  components: {},
  watch: {},
  methods: {
    closeModal() {
      this.$emit("closeModal");
    },

    changeCardType() {},

    async submit() {
      this.loading = true;
      try {
        const result = await this.$store.dispatch("payments/registerCard", {
          cardNo: this.cardNo,
          cardPw: this.cardPw,
          expireMonth: this.expireMonth,
          expireYear: this.expireYear,
          identifyNumber: this.identifyNumber,
          registeredFrom: this.registeredFrom
        });

        this.loading = false;

        if (result.success) {
          alert("결제카드 등록이 완료되었습니다.😄");
          if (this.registeredFrom == "MODAL") {
            return this.closeModal();
          } else if (this.registeredFrom === "PAGE") {
            return this.$router.go();
          }
        } else {
          const errorMessages = {
            400: "올바르지않은 요청입니다[400]",
            401: "올바르지않은 요청입니다[401]",
            406: "카드는 최대 3개까지 등록가능합니다",
            4040: "에러가 발생하였습니다[4040]",
            4041: result.popup
              ? `카드등록에 실패하였습니다.\n사유: ${result.popup}`
              : "카드인증에 실패하였습니다.",
            500: "에러가 발생하였습니다[500]"
          };

          const alertMessage =
            errorMessages[result.code] ||
            `에러가 발생하였습니다[${result.code}]`;
          alert(alertMessage);
        }
      } catch (e) {
        this.loading = false;
        console.error(e);
      }
    }
  },
  data() {
    return {
      cardType: "personal",
      loading: false,
      cardNo: "",
      cardPw: "",
      expireYear: "",
      expireMonth: "",
      identifyNumber: ""
    };
  },
  computed: {
    //카드 타입에 따른 label, name 제어
    identifyNumberText() {
      if (this.cardType) {
        return { KOR: "생년월일 6자리", ENG: "identifyNumber" };
      } else {
        return { KOR: "사업자등록번호", ENG: "vatNumber" };
      }
    }
  },

  async mounted() {},
  props: ["registeredFrom"]
};
</script>
